import init, { report3, report4 } from "@evideo/telemetry-core";
import store from "@/store";

// telemetry-core wasm read_token 约定：localStorage.teacher_token
const TEACHER_TOKEN_KEY = "teacher_token";

let runtimePromise: Promise<void> | null = null;

/**
 * 曲谱上报运行时初始化：init telemetry 加密库 + 给 display 注入加解密 hook。
 *
 * 曲谱加解密统一走 base64 字符串协议（report3 加密 / report4 解密），
 * Uint8Array<->string 适配由 display 内部完成，宿主只注入 telemetry 原生函数。
 *
 * 前置：须在 window.initSheetLib()（window.Display 就绪）之后调用。
 * 未登录（无 token）时跳过，保持明文链路。
 *
 * 幂等：多次调用复用同一 Promise；失败仅记日志并清空缓存以便重试，不阻断渲染。
 * 注：window.Display 已在 src/type.d.ts 声明为 any，此处直接使用。
 */
export const ensureSheetReportRuntime = (): Promise<void> => {
  if (runtimePromise) {
    return runtimePromise;
  }
  const token = store.state.token;
  if (!token) {
    return Promise.resolve();
  }
  // 写入 localStorage（telemetry wasm read_token 约定），须在 init 之前写
  localStorage.setItem(TEACHER_TOKEN_KEY, token);
  // 曲谱加密 telemetry 策略端点（/report-runtime-env）所在的 resource-center 域名（带 https://）
  // 注意：VUE_APP_RESOURCE_CENTER_HOST 实为 exam-center-service（OSS 用），与此不同
  const domain = process.env.VUE_APP_TELEMETRY_DOMAIN;
  if (!domain) {
    return Promise.resolve();
  }

  runtimePromise = (async () => {
    await init({ domain });
    const setHooks = window.Display?.setSheetReportHooks;
    if (setHooks) {
      setHooks({ report3, report4 });
    }
  })().catch((error) => {
    runtimePromise = null;
    console.error("[sheetReport] 初始化失败:", error);
  });
  return runtimePromise;
};
